<template>
  <div class="reject-form__popup">
    <div class="reject-form__popup-title">{{i18n.lbl_reject_message()}}</div>
    <form @submit.prevent="submit"
          class="reject-form__form">
      <div class="reject-form__row">
        <div class="reject-form__field">
          <textarea-field v-model="form.rejectReason"
                          name="reject-message"
                          v-validate="'required'" />
        </div>
      </div>
      <div class="reject-form__action-btn-wrapper">
        <md-button class="md-primary"
          @click="cancel"
          :disabled="isPending"
        >{{ i18n.lbl_cancel() }}</md-button>
        <md-button type="submit" class="md-primary"
          :disabled="isPending"
        >{{ i18n.lbl_submit() }}</md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { i18n } from '@js/i18n'
import FormMixin from '@com/mixins/form.mixin'

export default {
  components: { },
  mixins: [FormMixin],
  data: _ => ({
    i18n,
    form: {
      rejectReason: ''
    }
  }),

  methods: {
    async submit () {
      if (!await this.isValid()) return
      this.$emit('submit-reject-message', this.form.rejectReason)
    },
    cancel () {
      this.$emit('close-request')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .reject-form__popup-title {
    line-height: 1.625rem;
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }

  .reject-form__form {
    display: flex;
    flex-direction: column;
  }

  .reject-form__row {
    display: flex;
    justify-content: space-between;
  }

  .reject-form__field {
    width: 100%;
  }

  .reject-form__action-btn-wrapper {
    text-align: right;
    margin-right: -1.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/modals/Contracts.RejectForm.vue